export default "__VITE_ASSET__2qmWrXXQ__"